import angular from 'angular'
import './checklist.service'
import './edit/edit.controller'
import './empty/empty.controller'
import './users/users.controller'
import './users/users.service'

angular
  .module('admin.checklist', [
    'admin.checklist.service',
    'admin.checklist.edit',
    'admin.checklistempty.edit',
    'admin.checklist.users',
  ])
  .controller('ChecklistCtrl', ChecklistCtrl)

/** @ngInject */
function ChecklistCtrl($state, $scope, $timeout, ChecklistService) {
  var vm = this
  vm.model = {}
  vm.items = []
  vm.itemsPublished = []
  vm.itemsArchived = []
  vm.searchChecklistDraft = ''
  vm.searchChecklistPublished = ''
  vm.searchChecklistArchived = ''

  var tab = localStorage.getItem('tabchecklist')
  if (tab !== null) {
    if (tab === 'manage') {
      $('#managePublished').removeClass('active')
      $('#manageArchived').removeClass('active')
      $('#manageEmptystate').removeClass('active')
      $('#manage').addClass('active')
      $('#managechecklistdraft').addClass('active')
    } else if (tab === 'managePublished') {
      $('#manage').removeClass('active')
      $('#manageArchived').removeClass('active')
      $('#manageEmptystate').removeClass('active')
      $('#managePublished').addClass('active')
      $('#managechecklistpublished').addClass('active')
    } else if (tab === 'manageArchived') {
      $('#manage').removeClass('active')
      $('#managePublished').removeClass('active')
      $('#manageEmptystate').removeClass('active')
      $('#manageArchived').addClass('active')
      $('#managechecklistchived').addClass('active')
    } else if (tab === 'manageEmptystate') {
      $('#manage').removeClass('active')
      $('#managePublished').removeClass('active')
      $('#manageArchived').removeClass('active')
      $('#manageEmptystate').addClass('active')
      $('#manageemptystate').addClass('active')
    }
  } else {
    $('#manage').addClass('active')
    $('#managechecklistdraft').addClass('active')
  }

  vm.tabManage = function() {
    $('#managePublished').removeClass('active')
    $('#manageArchived').removeClass('active')
    $('#manageEmptystate').removeClass('active')
    $('#manage').addClass('active')
    localStorage.setItem('tabchecklist', 'manage')
  }

  vm.tabManagePublished = function() {
    $('#manageArchived').removeClass('active')
    $('#manage').removeClass('active')
    $('#manageEmptystate').removeClass('active')
    $('#managePublished').addClass('active')
    localStorage.setItem('tabchecklist', 'managePublished')
  }

  vm.tabManageArchived = function() {
    $('#managePublished').removeClass('active')
    $('#manage').removeClass('active')
    $('#manageEmptystate').removeClass('active')
    $('#manageArchived').addClass('active')
    localStorage.setItem('tabchecklist', 'manageArchived')
  }

  vm.tabManageEmptyState = function() {
    $('#managePublished').removeClass('active')
    $('#manage').removeClass('active')
    $('#manageArchived').removeClass('active')
    $('#manageEmptystate').addClass('active')
    localStorage.setItem('tabchecklist', 'manageEmptystate')
  }

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublished() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.perPage2 = 25
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalUsers3 = 0
    vm.oldPage3 = 0
    vm.perPage3 = 25
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPagination()
  reloadPaginationPublished()
  reloadPaginationArchived()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    ChecklistService.search(vm.searchChecklistDraft, 0, vm.oldPage, 25).then(function(result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['k-scope']) {
          if (items[i]['k-scope'] === 1) {
            items[i].scope = 'Collectible'
          } else if (items[i]['k-scope'] === 2) {
            items[i].scope = 'Set'
          } else if (items[i]['k-scope'] === 3) {
            items[i].scope = 'Channel'
          }
        }
        if (items[i]['k-chal']) {
          if (items[i]['k-chal'] === 1) {
            items[i].chal = 'First N'
          } else if (items[i]['k-chal'] === 2) {
            items[i].chal = 'Completion Rank'
          } else if (items[i]['k-chal'] === 3) {
            items[i].chal = 'Top N'
          } else if (items[i]['k-chal'] === 4) {
            items[i].chal = 'Value Rank'
          } else if (items[i]['k-chal'] === 5) {
            items[i].chal = 'Completion'
          } else if (items[i]['k-chal'] === 6) {
            items[i].chal = 'Hold Em'
          } else if (items[i]['k-chal'] === 7) {
            items[i].chal = 'Hold Em Fast'
          }
        }

        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.items = items
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    ChecklistService.search(vm.searchChecklistPublished, 1, vm.oldPage2, 25).then(function(result) {
      var items = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.itemsPublished = items
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage3 - 25
    } else {
      vm.first3 = false
    }

    ChecklistService.search(vm.searchChecklistArchived, 2, vm.oldPage3, 25).then(function(result) {
      var items = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }
      }

      vm.itemsArchived = items
    })
  }

  function loadEmptyState() {
    ChecklistService.listEmptyState().then(function(result) {
      vm.itemsEmptyState = result.results
    })
  }

  load(1)
  loadPublished(1)
  loadArchived(1)
  loadEmptyState()

  vm.pageChanged = function(newPage) {
    load(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.pageChangePublished = function(newPage) {
    loadPublished(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.pageChangeArchived = function(newPage) {
    loadArchived(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  vm.add = function() {
    if (tab === 'manageEmptystate') {
      $state.go('admin.checklist.empty', { id: 0 })
    } else {
      $state.go('admin.checklist.edit', { id: 0 })
    }
  }

  vm.edit = function(item) {
    $state.go('admin.checklist.edit', { id: item.id })
  }

  vm.editEmptyState = function(item) {
    $state.go('admin.checklist.empty', { id: item.id })
  }

  vm.reward = function(item) {
    $state.go('admin.checklist.reward', { id: item.id })
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChecklistService.remove(item.id).then(
            function() {
              $state.reload()
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 200)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.deleteEmptyState = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChecklistService.removeEmptyState(item.id).then(
            function() {
              $state.reload()
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 200)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.publish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          var date = parseInt(new Date().getTime() + '000')
          ChecklistService.update(item.id, { 'ts-p': date }).then(function() {
            ChecklistService.publish(item.id).then(
              function() {
                load(1)
                loadPublished(1)
                loadArchived(1)
              },
              function(err) {
                $timeout(function() {
                  swal(err.error.message, '', 'error')
                }, 250)
              },
            )
          })
        }
      },
    )
  }

  vm.unpublish = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChecklistService.unpublish(item.id).then(
            function() {
              load(1)
              loadPublished(1)
              loadArchived(1)
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 250)
            },
          )
        }
      },
    )
  }

  vm.archive = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ChecklistService.update(item.id, { st: 2 }).then(
            function() {
              $state.reload()
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 200)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.cancel = function() {
    $state.go('admin.home')
  }

  vm.viewUsers = function(item) {
    $state.go('admin.checklist.users', { id: item.id })
  }

  var watch = $scope.$watch('vm.searchChecklistDraft', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPagination()
        load(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.searchChecklistDraft.length < 2) {
      return
    }

    reloadPagination()
    load(1)
  })

  var watch1 = $scope.$watch('vm.searchChecklistPublished', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationPublished()
        loadPublished(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.searchChecklistPublished.length < 2) {
      return
    }

    reloadPaginationPublished()
    loadPublished(1)
  })

  var watch2 = $scope.$watch('vm.searchChecklistArchived', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        reloadPaginationArchived()
        loadArchived(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.searchChecklistArchived.length < 2) {
      return
    }

    reloadPaginationArchived()
    loadArchived(1)
  })

  $scope.$on('$destroy', function() {
    watch()
    watch1()
    watch2()
  })
}
